"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderType = void 0;
var OrderType;
(function (OrderType) {
    OrderType["PreOrder"] = "Pre-Order";
    OrderType["ReOrder"] = "Re-Order";
    OrderType["MultiplePreOrder"] = "Pre-Order-Multiple";
    OrderType["DropShip"] = "Drop ship";
    OrderType["ReturnOrder"] = "Return";
    OrderType["WarrantyOrder"] = "Warranty";
    OrderType["Bulks"] = "Bulks";
    OrderType["Replacement"] = "Replacement";
    OrderType["DemoSets"] = "Demo Sets";
    OrderType["ConsignmentReturn"] = "Consignment Return";
    OrderType["ConsignmentSale"] = "Consignment Sale";
    OrderType["EventOrder"] = "Event Order";
    OrderType["ExperienceItems"] = "Experience Items";
    OrderType["MarketingMaterial"] = "Marketing Material";
    OrderType["MediaSamples"] = "Media Samples";
    OrderType["SalesTeamSamples"] = "Sales Team Samples";
    OrderType["Sponsorship"] = "Sponsorship";
    OrderType["StockClearance"] = "Stock Clearance";
    OrderType["Subscription"] = "Subscription";
    OrderType["Unknown"] = "";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
//# sourceMappingURL=order-type.enum.js.map